<script setup>
import RankingCreatorsTop3 from '@/components/Ranking/RankingCreators/RankingCreatorsTop3.vue'
import RankingCreatorsList from '@/components/Ranking/RankingCreators/RankingCreatorsList.vue'
</script>

<template>
  <RankingCreatorsTop3/>

  <RankingCreatorsList class="mt-8"/>
</template>